// 形态判定（文档 23 §2）：只看可用宽度和指针，绝不看 UA。
// iPadOS Safari 默认「请求桌面网站」，UA 伪装成 Mac，靠 UA 一定判错。
import { useSyncExternalStore } from 'react';

export type FormFactor = 'desktop' | 'tablet' | 'phone';

function compute(): FormFactor {
  // Local visual QA can force the device class in a desktop browser that lacks touch input.
  const forced = import.meta.env.DEV ? new URLSearchParams(window.location.search).get('__v2FormFactor') : null;
  if (forced === 'phone' || forced === 'tablet' || forced === 'desktop') return forced;
  const w = window.innerWidth;
  if (w < 768) return 'phone';
  const coarse = window.matchMedia('(pointer: coarse)').matches || navigator.maxTouchPoints > 1;
  if (coarse) return 'tablet';
  if (w < 1024) return 'tablet';
  return 'desktop';
}

let current: FormFactor = typeof window === 'undefined' ? 'desktop' : compute();
const listeners = new Set<() => void>();

function update() {
  const next = compute();
  if (next !== current) {
    current = next;
    document.documentElement.dataset.ff = next;
    listeners.forEach((l) => l());
  }
}

if (typeof window !== 'undefined') {
  document.documentElement.dataset.ff = current;
  window.addEventListener('resize', update);
  window.matchMedia('(pointer: coarse)').addEventListener?.('change', update);
}

export function useFormFactor(): FormFactor {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => current,
  );
}

/** 手机 / iPad 窄宽下是否把「列表 + 详情」拆成两页（push 导航） */
export function useIsNarrow() {
  return useFormFactor() === 'phone';
}
